import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import ActiveProductActions from '../constants/active_product/actions';
import ProductModel from './models/product';

class ActiveProductStoreClass extends ReduceStore {
    getInitialState() {
        return {
            product: null
        };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.ACTIVE_PRODUCT_ACTION) {
            switch (action.type) {
                case ActiveProductActions.SET_ACTIVE_PRODUCT:
                    state.product = new ProductModel(action.payload);
                    this.__emitChange();
                    break;
                case ActiveProductActions.UNSET_ACTIVE_PRODUCT:
                    state.product = null;
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const ActiveProductStore = new ActiveProductStoreClass(Dispatcher);
export default ActiveProductStore;